// extracted by mini-css-extract-plugin
module.exports = {"root":"context-menu-content_root__SZV7k"};